/* 🤖 this file was generated by svg-to-ts */
export const svgMeasureYourself: {
    name: "measure-yourself";
    data: string;
} = {
    name: "measure-yourself",
    data: '<svg xmlns="http://www.w3.org/2000/svg" id="ng__measure-yourself" fill="none" version="1.1" viewBox="0 0 24 24"><path stroke="#696969" stroke-linecap="round" stroke-linejoin="round" d="M16.9573 4.73301 20.0172 7.79287C20.0172 7.79287 20.7822 8.55784 20.0172 9.3228L10.0727 19.2674C10.0727 19.2674 9.3077 20.0323 8.54273 19.2674L5.48287 16.2075C5.48287 16.2075 4.71791 15.4425 5.48287 14.6776L15.4274 4.73301C15.4274 4.73301 16.1924 3.96805 16.9573 4.73301ZM13.8975 6.26294 15.6824 8.04786M11.6025 8.55795 13.3875 10.3429M9.30762 10.853 11.0925 12.6379M7.0127 13.1472 8.79761 14.9321"/></svg>',
};
